'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

var _Alert = require('../../ui/Alert');

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Tone-Banner (success). Faehrt seit 2026-06 ueber das zentrale <Alert>-Primitiv.
// Verhaltens-erhaltend bis auf den SICHTBAREN Bugfix: success-Gruen jetzt
// approveColor (#2e9e5b) statt theme.green (#7ac943, grelles Gift-Gruen) — analog
// ButtonStyled.APPROVE. faCheck-Icon, width:100% (fullWidth=true).
var Success = function Success(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    _Alert2.default,
    {
      className: className,
      tone: _Alert.ALERT_TONES.SUCCESS,
      icon: _freeSolidSvgIcons.faCheck,
      fullWidth: true
    },
    children
  );
};

Success.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string
} : {};

Success.defaultProps = {
  className: undefined
};

exports.default = Success;
module.exports = exports['default'];